import React from 'react'; 
import {Glyphicon} from 'react-bootstrap';
import {FormattedDate, FormattedTime} from 'react-intl';
import {isSameDate} from '../common_components/date_functions.js'


export default function MeetingDate({meeting}){ 
  return(
    <div className="">
      <Glyphicon glyph="calendar" />&nbsp;&nbsp;
      <FormattedDate value={meeting.start_date}/>&nbsp;
      <FormattedTime value={meeting.start_date} hour12={true} />
      &nbsp; -
      {renderFinishDate(meeting)}
      <FormattedTime value={meeting.finish_date} hour12={true} />        
    </div>
  );
}

function renderFinishDate(meeting){
  let element = <span>&nbsp;&nbsp;</span>
  if( !isSameDate(meeting.start_date, meeting.finish_date) ){
    element = <span>&nbsp;&nbsp;<FormattedDate value={meeting.finish_date}/>&nbsp;</span>
  }
  return element;
}